export const FETCH_RULES_REQUEST = 'FETCH_RULES_REQUEST';
export const FETCH_RULES_SUCCESS = 'FETCH_RULES_SUCCESS';
export const FETCH_RULES_FAILURE = 'FETCH_RULES_FAILURE';

export const CREATE_RULE_REQUEST = 'CREATE_RULE_REQUEST';
export const CREATE_RULE_SUCCESS = 'CREATE_RULE_SUCCESS';
export const CREATE_RULE_FAILURE = 'CREATE_RULE_FAILURE';

export const UPDATE_RULE_REQUEST = 'UPDATE_RULE_REQUEST';
export const UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';
export const UPDATE_RULE_FAILURE = 'UPDATE_RULE_FAILURE';

export const DELETE_RULE_REQUEST = 'DELETE_RULE_REQUEST';
export const DELETE_RULE_SUCCESS = 'DELETE_RULE_SUCCESS';
export const DELETE_RULE_FAILURE = 'DELETE_RULE_FAILURE';

export const fetchRulesRequest = (mappingId) => ({ type: FETCH_RULES_REQUEST, payload: mappingId });
export const fetchRulesSuccess = (rules) => ({ type: FETCH_RULES_SUCCESS, payload: rules });
export const fetchRulesFailure = (error) => ({ type: FETCH_RULES_FAILURE, payload: error });

export const createRuleRequest = (data) => ({ type: CREATE_RULE_REQUEST, payload: data });
export const createRuleSuccess = (rule) => ({ type: CREATE_RULE_SUCCESS, payload: rule });
export const createRuleFailure = (error) => ({ type: CREATE_RULE_FAILURE, payload: error });

export const updateRuleRequest = (id, data) => ({ type: UPDATE_RULE_REQUEST, payload: { id, data } });
export const updateRuleSuccess = (rule) => ({ type: UPDATE_RULE_SUCCESS, payload: rule });
export const updateRuleFailure = (error) => ({ type: UPDATE_RULE_FAILURE, payload: error });

export const deleteRuleRequest = (id) => ({ type: DELETE_RULE_REQUEST, payload: id });
export const deleteRuleSuccess = (id) => ({ type: DELETE_RULE_SUCCESS, payload: id });
export const deleteRuleFailure = (error) => ({ type: DELETE_RULE_FAILURE, payload: error });
